import React from 'react';
import { Paper } from '@mui/material';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import RoofingIcon from '@mui/icons-material/Roofing';
import ParkIcon from '@mui/icons-material/Park';
import OilBarrelIcon from '@mui/icons-material/OilBarrel';
import { useMapContext } from '../Map/MapContext';

const LIDSummary = () => {
    const {
        selectedFeature,
        devPlanContent,
        aggregatedCounts
    } = useMapContext();

    const selectedFeatureData = selectedFeature.Data;

    const renderLIDCountWithIcon = (lidType, count) => {
        const getIcon = (type) => {
            switch(type) {
                case 'RG1': return <LocalFloristIcon />;
                case 'GR1': return <RoofingIcon />;
                case 'Planter': return <ParkIcon />;
                case 'RB12': return <OilBarrelIcon />;
                default: return null;
            }
        };
    
        return (
            <div key={lidType} style={{ display: 'flex', alignItems: 'center', marginRight: '15px' }}>
                {getIcon(lidType)}
                <span style={{ marginLeft: '5px' }}>{count}</span>
            </div>
        );
    };

    const formatLIDData = (lidData) => {
        const lidTypeMapping = {
            RG1: "Rain Garden",
            Planter: "Tree Planter",
            GR1: "Green Roof",
            RB12: "Rain Barrel"
        };

        return Object.entries(lidData).map(([lidType, data]) => {
            const count = data.n_replicate;
            const area = data.area;
            const lidName = lidTypeMapping[lidType] || lidType;
            const pluralSuffix = count > 1 ? 's' : '';
            if (lidType === 'Planter') {
                return `${count} ${lidName}${pluralSuffix}`;
            } else {
                return `${count} ${lidName}${pluralSuffix} (area: ${area} sq ft)`;
            }
        }).join(', ');
    };

    return (
        <div
            style={{
                position: 'absolute',
                bottom: 20,
                left: 50,
                width: '300px',
                height: '250px',
                backgroundColor: '#071317',
                opacity: 0.9,
                zIndex: 10,
                borderRadius: '5px',
                padding: '10px',
                display: 'flex',
                flexDirection: 'column',
            }}
        > 
            <h5 style={{ color: '#94cfec', margin: '0 0 0 0' }}> Development Plan: </h5>
            <Paper elevation={3} style={{ 
                padding: '10px', 
                backgroundColor: '#1e2a30', 
                color: '#94cfec', 
                fontSize: '14px', 
                maxHeight: '90%', 
                minHeight: '90%',
                overflow: 'auto' 
            }}>
                <h4 style={{ color: '#94cfec', margin: '0 0 0 0' }}> Total: </h4>
                <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '10px' }}>
                    {Object.entries(aggregatedCounts).map(([lidType, count]) => 
                        renderLIDCountWithIcon(lidType, count)
                    )}
                </div>
                <h4 style={{ color: '#94cfec', margin: '0 0 0 0' }}> Subcatchment Breakdown: </h4>
                {Object.entries(devPlanContent).map(([subcatchment, lidData]) => (
                    <p  
                        key={subcatchment} 
                        style={{ 
                            color: selectedFeatureData && selectedFeatureData.NAME === subcatchment ? '#000' : '#94cfec',
                            margin: '5px 0', 
                            padding: '2px 5px',
                            backgroundColor: selectedFeatureData && selectedFeatureData.NAME === subcatchment ? '#67ea04' : 'transparent',
                            borderRadius: '3px'
                        }}
                    >
                        <strong>{subcatchment}:</strong> {formatLIDData(lidData)}
                    </p>
                ))}
            </Paper>
        </div>
    );
};

export default LIDSummary;